<template>
  <div class="py-2">
    <label class="form-label label-input">{{ label }}</label>

    <select v-if="isLiberada" @change="$emit('enviaOpcao', opcao)" class="form-select input-select"
      :class="getClasses(size)" v-model="option" :disabled="disabled">
      <!-- <option :value="option">
        {{ option }}
      </option> -->
      <option v-for="(item, index) in opcoes" :key="index" :value="item.opcao" :selected="option">
        {{ item.opcao }}
      </option>
    </select>

    <select v-else @change="$emit('enviaOpcao', opcao)" class="form-select input-select" :class="getClasses(size)"
      v-model="opcao" :disabled="disabled">
      <option v-for="(item, index) in opcoes" :key="index" :value="item.opcao">
        {{ item.opcao }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "inputSelect",
  props: {
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    caminhoIMG: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: false,
    },
    opcoes: {
      type: Array,
      default: [],
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isLiberada: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  computed: {
    option() {
      if (this.isLiberada) {
        return this.opcoes.at(-1).opcao
      } else {
        return this.opcoes[0].opcao
      }
    }
  },
  data() {
    return {
      opcao: this.opcoes[0].opcao,
    }
  },
  emits: [
    'enviaOpcao'
  ],
  methods: {
    getClasses(size) {
      return size ? `form-select-${size}` : null;
    },
  },
};
</script>
